//import logo from './logo.svg';
import './App.css';
import { Header } from './component/Header/Header';
import { Resumecontainer } from './component/Resumecontainer/Resumecontainer';
import { Skillcontainer } from './component/Skillcontainer/Skillcontainer';
import { Topcontainer } from './component/Topcontainer/Topcontainer';
import { ContactDetails } from './component/Contact/contact';
import { Joinwithme } from './component/Withme/withme';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Projectcontainer } from './component/Projectcontainer/Projectcontainer';


function App() {
  return (
    <div>
    

      <BrowserRouter>
      <Header/>
        <Routes>
          <Route path="/withme" element={<Joinwithme />} />
          <Route path="/" element={< >
            <Topcontainer/>
<Skillcontainer/>
<Resumecontainer/>
<Projectcontainer />
<ContactDetails /> </>} />

          

        </Routes>
      </BrowserRouter>


    </div>
  );
}

export default App;










